import React from "react";
import { withStyles } from "@material-ui/core/styles";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelActions from "@material-ui/core/ExpansionPanelActions";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import { Link } from "react-router-dom";
import SelectAsDefaultButton from "./select-as-default";
import EditButton from "./edit-item-button";
import DeleteButton from "./delete-item-button";
import TagsManager from "../../../tags-manager";

const styles = theme => ({
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});

const LayerItem = ({ id, name, description, isDefault, query, classes }) => {
  const row = { id, name, description, isDefault };
  return (
    <ExpansionPanel>
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
        <Typography className={classes.heading}>{name}</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <Typography>{description}</Typography>
      </ExpansionPanelDetails>

      <Divider />
      <ExpansionPanelActions>
        <DeleteButton query={query} row={row} />
        <EditButton query={query} row={row} />
        <SelectAsDefaultButton query={query} id={id} isDefault={isDefault} />
        <TagsManager contextType="LAYER" contextId={id} isResource={false} />
        <Button size="small" component={Link} to={`/admin/layers/${id}/stats`}>
          Datos estadísticos
        </Button>
        <Button size="small" component={Link} to={`/admin/layers/${id}/containers`}>
          Ver contenedores
        </Button>
      </ExpansionPanelActions>
    </ExpansionPanel>
  );
};

export default withStyles(styles)(LayerItem);



// WEBPACK FOOTER //
// ./src/components/admin/carto/layers/item.js